import SideBarElem from "./SideBarElem";

export default function SideBarBatch({ content, list }) {
  return (
    <div className="m-1 p-1 border border-black z-0 w-[97%] text-center bg-primary-yellow">
      <p className="m-1 p-1 border-2 border-black font-bold bg-white  sm:text-sm md:text-base lg:text-lg">
        {content}
      </p>

      <div className="m-1 p-1 flex flex-col justify-center">
        {list &&
          list.map((elem) => (
            <SideBarElem key={elem.id} content={elem} contentType={"student"} />
          ))}
      </div>
    </div>
  );
}
